import { useMemo } from 'react'
import { type MultiSelectOption } from '../../../components/MultiSelectDropdown/MultiSelectDropdown'
import { IntegrationServiceId } from '../../../common/integrations'
import { useGetIntegrationEntitiesQuery } from '../../../store/integrations/integrations'

export type SalesforceEventEntityType = 'event_types' | 'event_subtypes'

interface SalesforceEventEntity {
  value: string
  label: string | null
}

interface SalesforceEventEntityData {
  eventTypes?: SalesforceEventEntity[]
  eventSubtypes?: SalesforceEventEntity[]
}

export interface SalesforceEventEntityOptions {
  options: MultiSelectOption[]
  isFetching: boolean
}

export const useSalesforceEventEntityOptions = (accountId: string, entityType: SalesforceEventEntityType, enabled: boolean): SalesforceEventEntityOptions => {
  const { data, isError, isFetching } = useGetIntegrationEntitiesQuery(
    { accountId, connector: IntegrationServiceId.SALESFORCE, entityType, suppressGlobalErrorToast: true },
    { skip: !enabled },
  )

  const options = useMemo((): MultiSelectOption[] => {
    if (isError || !data?.data) {
      return []
    }
    const responseData = data.data as SalesforceEventEntityData
    const entities = (entityType === 'event_types' ? responseData.eventTypes : responseData.eventSubtypes) ?? []
    return entities.map(({ value, label }) => ({ id: value, label: label ?? value }))
  }, [data, entityType, isError])

  return { options, isFetching }
}
